import { PropsWithChildren, ReactNode } from 'react';
import { StyledWrapper, StyledBadgeWrapper } from './styles';

export interface ProductsListWrapperProps extends PropsWithChildren {
  isSecondLevelActive?: boolean;
  isFirstProduct?: boolean;
  isShownProductType?: boolean;
  badge?: ReactNode;
}

export default function ProductsListWrapper(props: ProductsListWrapperProps) {
  const {
    isSecondLevelActive,
    isFirstProduct,
    isShownProductType,
    badge,
    children,
  } = props;

  return (
    <StyledWrapper
      active={isSecondLevelActive}
      isBadge={!!badge}
      isFirstProduct={isFirstProduct}
      isShownProductType={isShownProductType}
    >
      {badge && (
        <StyledBadgeWrapper
          active={isSecondLevelActive}
          className="informa-payment-product-card-badge"
        >
          {badge}
        </StyledBadgeWrapper>
      )}

      {children}
    </StyledWrapper>
  );
}
